import axios from "axios";

const http = axios.create({
	baseURL: `/api`,
	headers: {
		"Content-Type": "application/json",
	},
});

export default http;
